module.exports = __webpack_public_path__ + "img/sustainability.17bac4a8.png";